import styled from '@emotion/styled';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';

import LoggedInPageTemplate from '../LoggedInPageTemplate/LoggedInPageTemplate';
import Breadcrumbs from './Breadcrumbs';

import SidePanel from './SidePanel';

export const DRAWER_WIDTH = 210;
export const HEADER_HEIGHT = 65;
const appBarHeight = 125;

const BreadcrumbsWrapper = styled.div`
  display: flex;
`;

const CenterPanelWrapper = styled.div`
  padding-left: calc(${DRAWER_WIDTH}px + 40px);
  padding-right: 40px;

  background-color: white;
`;

const TemplateContent = styled.div`
  margin: 0 auto;
`;

const ApplicationContentWrapper = styled.div`
  height: calc(100vh - ${appBarHeight}px);
  overflow-y: scroll;
`;

function ApplicationTemplate({ menu, children }) {
  return (
    <LoggedInPageTemplate>
      <TemplateContent>
        <Drawer
          id="sideDrawer"
          variant="permanent"
          sx={{
            position: 'fixed',
            zIndex: 1,
            width: DRAWER_WIDTH,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: {
              width: DRAWER_WIDTH,
              boxSizing: 'border-box',
            },
          }}>
          <Toolbar /> {/* needed to offset appbar */}
          <SidePanel
            menu={menu}
            drawerSize={DRAWER_WIDTH}
          />
        </Drawer>
        <CenterPanelWrapper>
          <BreadcrumbsWrapper>
            <Breadcrumbs />
          </BreadcrumbsWrapper>
          <ApplicationContentWrapper>{children}</ApplicationContentWrapper>
        </CenterPanelWrapper>
      </TemplateContent>
    </LoggedInPageTemplate>
  );
}

export default ApplicationTemplate;
